export default __webpack_public_path__ + "static/media/agri-products.2c5e1475.webp";